import React from 'react';
import StylePackLoadingSkeleton from './style-pack-loading-skeleton';
import Skeleton from 'react-loading-skeleton';

const btnStyle = {
    backgroundColor: '#312F38',
    flex:	1,
    borderRadius: '10px'
}

const fakeGroups =[{ id: 'test'}, { id: 'test2'}, { id: 'test3'}, { id: 'test4'},
	{ id: 'test5'}, { id: 'test6'}, { id: 'test7'}]

export default function StylePackLoadingTabSkeleton() {
	return (
		<div className="style-packs-tab">
			<div className="magic-telly-wand-gradient" data-testid="magic-telly-wand-gradient" />
			<div className='style-pack-info-content-header tab-header'>
				<h3 className='bl-font-header'>Stylepacks</h3>
				<sup className='bl-font-header'>TM</sup>
			</div>

			<div style={{marginBottom: '16px'}}>
				<div style={{marginBottom: '16px', display: 'flex', gap: '8px'}}>
					<Skeleton height={60} width={60} style={btnStyle}/>
					<Skeleton height={60} width={60} style={btnStyle}/>
					<Skeleton height={60} width={67} style={btnStyle}/>
					<Skeleton height={60} width={74} style={btnStyle}/>
					<Skeleton height={60} width={87} style={btnStyle}/>
					<Skeleton height={60} width={72.5} style={btnStyle}/>
				</div>
				<div style={{minHeight:'32px', display: 'flex', gap: '8px'}}>
					<Skeleton height={32} width={309} style={{...btnStyle, flex: 6, borderRadius: '99px'}}/>
					<Skeleton height={32} width={144} style={{...btnStyle, minWidth: '144px', borderRadius: '99px'}}/>
				</div>
			</div>

			<div className='style-packs'data-testid="style-packs">
				{fakeGroups.map((group, index) => <StylePackLoadingSkeleton id={group.id} key={index + '-skeleton'}/>)}
			</div>
		</div>
	);
}
